import { PurchaseRouting } from './../../purchase/purchase.routing';
import { HttpService } from "@/core";
import { generateUuid } from "@/utils";
import { TeamPageReq, TeamPageResp } from "./team.interface";


export class TeamService {
  static usePageApi() {
    const api = (data: TeamPageReq) =>
      HttpService.axios({
        method: "POST",
        url: "/project_team_independent/page",
        data,
      });
    return HttpService.usePagination<TeamPageResp>(api);
  }

  static useTeamUserApi() {
    const api = (projectTeamIndependentId) =>
      HttpService.axios({
        method: "GET",
        url: `/project_team_independent_user/${projectTeamIndependentId}/list`,
      });
    return HttpService.useRequest<any>(api);
  }
  static useTeamUserByProjectIdApi() {
    const api = (projectId) =>
      HttpService.axios({
        method: "GET",
        url: `/project_team_independent_user/${projectId}/listProjectId`,
      });
    return HttpService.useRequest<any>(api);
  }
  
  static useUpdateTeamUserApi() {
    const api = (projectTeamIndependentId,data) =>
      HttpService.axios({
        method: "PUT",
        url: `/project_team_independent_user/${projectTeamIndependentId}/updateDate`,
        data
      });
    return HttpService.useRequest<any>(api);
  }

  static useTeamRolesApi() {
    const api = (projectId) =>
      HttpService.axios({
        method: "GET",
        url: `/project_team_independent_user/projectTeamRole/list/${projectId}`,
      });
    return HttpService.useRequest<any>(api);
  }

  static useUpdateTeamRolesApi() {
    const api = (projectId,data) =>
      HttpService.axios({
        method: "POST",
        url:
         `/project_team_independent_user/updateProjectTeamRoles/${projectId}`,
        data
      });
    return HttpService.useRequest<any>(api);
  }
}
